class FeedbackBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    theme.feedback = this;
    this.message_container = this.querySelector(".feedback-bar--message");
    this.message_json = JSON.parse(this.querySelector("script").innerHTML);

    // Check if feedback bar was previously closed and not triggered
    if (sessionStorage.getItem("feedback-bar-dismissed") === "true" && !this.isTriggered()) {
      this.setAttribute("aria-hidden", "true");
      return;
    }

    this.load();

    // Add close button if not already present
    if (!this.querySelector(".feedback-bar--close")) {
      const closeBtn = document.createElement("button");
      closeBtn.innerText = "×";
      closeBtn.setAttribute("aria-label", "Dismiss message");
      closeBtn.classList.add("feedback-bar--close");
      closeBtn.addEventListener("click", () => this.close());
      this.appendChild(closeBtn);
    }
  }

  load(forceKey = false) {
    const hash = window.location.hash.substring(1);
    const key = forceKey || hash.replace("feedback-bar--", "");

    if (this.message_json[key]) {
      this.message_container.innerText = this.message_json[key];
      this.open();
    }
  }

  open() {
    this.setAttribute("aria-hidden", "false");
    setTimeout(() => {
      this.setAttribute("data-transition-active", "true");
    }, 5);
  }

  close() {
    this.setAttribute("data-transition-active", "false");

    // Save dismissal state to sessionStorage
    sessionStorage.setItem("feedback-bar-dismissed", "true");

    const hideBar = () => {
      this.setAttribute("aria-hidden", "true");
      this.removeEventListener("transitionend", hideBar);
    };

    const duration = getComputedStyle(this).transitionDuration;
    if (duration !== "0s") {
      this.addEventListener("transitionend", hideBar);
    } else {
      hideBar();
    }
  }

  // Check if the feedback bar is triggered (by specific condition or event)
  isTriggered() {
    // Define logic for when feedback bar is triggered again
    return sessionStorage.getItem("feedback-bar-triggered") === "true";
  }

  trigger(type, value) {
    if (type === "copy") {
      this.loadCopy();
    } else if (type === "quantity") {
      this.loadProductQuantity(value);
    }

    // Mark that the feedback bar was triggered again
    sessionStorage.setItem("feedback-bar-triggered", "true");
    this.load();
  }

  loadCopy() {
    navigator.clipboard.writeText(window.location.href);
    this.load("copied");
  }

  loadProductQuantity(quantity) {
    if (quantity === 0) {
      this.load("product--no-items");
    } else if (quantity === 1) {
      this.load("product--one-item");
    } else if (quantity > 1) {
      const message = this.message_json["product--n-items"].replace("[num_items]", quantity);
      this.message_json[`product--${quantity}-items`] = message;
      this.load(`product--${quantity}-items`);
    }
  }
}

customElements.define("feedback-bar-root", FeedbackBar);